import EventEmitter from 'es6-eventemitter';

export default class JobsService {

    constructor(http){
        this.http = http;
        this.events = new EventEmitter();
    }

    removeJob(id){
        return this.http.delete('api/failed-jobs', {
            body: { id:  id }
        });
    }

    queueDetails(queueName){
        return this.http.get('api/queue-details', {
            params: { q: queueName }
        });
    }

    deleteFailedJob(id){
        return this.http.delete('api/failed-jobs', { body: { id: id} });
    }

    getFailedJobs(){
        return this.http.get('api/failed-jobs');
    }

    retryJob(id){
        return this.http.post('api/failed-jobs/retry', { id: id });
    }

    removePendingJobs(queue){
        return this.http.delete('api/remove-pending-jobs', { body: {queue: queue } });
    }

}


// WEBPACK FOOTER //
// ./src/services/jobs.service.js